import pointsMailHomePageRouters from './points-mail-home-page/routers'
import pointsMailHomePageNewRouters from './points-mail-home-page-new/routers'
import productDetailsRouters from './product-details/routers'
import productSearchRouters from './product-search/routers'
import exchangeRecordRouters from './exchange-record/routers'
import mypointsRouters from './my-points/routers'
import rankEquityRouters from './rank-equity/routers'
import productOrderRouters from './product-order/routers'
import paymentDetailsRouters from './payment-details/routers'
import shopptingCartRouters from './shoppting-cart/routers'
import pointsMailCashierRouters from './points-mail-cashier/routers'
import recordsOfConsumptionRouters from './records-of-consumption/routers'
import myOrderRouters from './my-order/routers'
import myExtendedInsuranceRouters from './my-extended-insurance/routers'
import myStoredValueRouters from './my-stored-value/routers'
import commonProblemRouters from './more-services/routers'
import myCarRouters from './my-car/routers'
import pageaiMlServiceRouters from './page-mail-service/routers'
import pageMyRouters from './page-mail-my/routers'



export default [
  ...pointsMailHomePageRouters,
  ...productDetailsRouters,
  ...productSearchRouters,
  ...exchangeRecordRouters,
  ...mypointsRouters,
  ...rankEquityRouters,
  ...productOrderRouters,
  ...paymentDetailsRouters,
  ...shopptingCartRouters,
  ...pointsMailCashierRouters,
  ...recordsOfConsumptionRouters,
  ...myOrderRouters,
  ...myExtendedInsuranceRouters,
  ...myStoredValueRouters,
  ...commonProblemRouters,
  ...myCarRouters,
  ...pointsMailHomePageNewRouters,
  ...pageaiMlServiceRouters,
  ...pageMyRouters
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/routers.js